import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Drop head tags written by scripts/prerender.ts; Helmet manages them from here
document.head.querySelectorAll("[data-prerender]").forEach((el) => el.remove());

createRoot(document.getElementById("root")!).render(<App />);
